import React from 'react';

/**
 * A real `<a href>` that behaves like an SPA link.
 *
 * This exists for one reason: search engines follow `href` attributes,
 * they do not click buttons. The site previously navigated entirely
 * through `<button onClick>` handlers, which meant Google had no path
 * from the home page to any product — internal linking, and the crawl
 * and authority flow that depends on it, simply did not exist.
 *
 * Behaviour preserved for people:
 *  · plain left-click navigates in-app, no page reload
 *  · ctrl/cmd/shift/middle-click fall through to the browser, so
 *    "open in new tab" works the way it does on any other site
 *  · the status bar shows the destination on hover
 *
 * @param {string} href       destination path, e.g. "/shop/rings"
 * @param {Function} onClick  in-app navigation handler
 */
export default function Link({ href, onClick, children, className, ...rest }) {
  const handleClick = (e) => {
    // Let the browser handle anything that isn't a plain left-click
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
    ) return;

    e.preventDefault();
    if (onClick) onClick(e);
  };

  return (
    <a href={href} className={className} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}
